import { OrderByDir } from "../../api/generated"
import {
  ENROLLMENT_ROLE_EDITOR,
  ENROLLMENT_ROLE_FACILITATOR,
  ENROLLMENT_ROLE_OBSERVER,
  ENROLLMENT_ROLE_SCHEMA,
  ENROLLMENT_ROLE_STUDENT,
  ENROLLMENT_ROLE_TEACHER
} from "../constants"

export const ENROLLMENT_CONTROL_FILTER_BY_ALL_ROLES = 1
export const ENROLLMENT_CONTROL_FILTER_BY_ROLE_OBSERVER = 2
export const ENROLLMENT_CONTROL_FILTER_BY_ROLE_STUDENT = 3
export const ENROLLMENT_CONTROL_FILTER_BY_ROLE_FACILITATOR = 4
export const ENROLLMENT_CONTROL_FILTER_BY_ROLE_TEACHER = 5
export const ENROLLMENT_CONTROL_FILTER_BY_ROLE_EDITOR = 6
export const ENROLLMENT_CONTROL_FILTER_BY_STAFF_ROLES = 7

export const ENROLLMENT_CONTROL_SORT_BY_DATE_ACTIVE = 1
export const ENROLLMENT_CONTROL_SORT_BY_DATE_JOINED = 2

export const getFilterVariables = (filter) => {
  switch (filter) {
    case ENROLLMENT_CONTROL_FILTER_BY_ALL_ROLES:
      return {
        filter,
        // roleFilter: null // not including editor role for now
        roleFilter: {
          in: [
            ENROLLMENT_ROLE_SCHEMA[ENROLLMENT_ROLE_OBSERVER],
            ENROLLMENT_ROLE_SCHEMA[ENROLLMENT_ROLE_STUDENT],
            ENROLLMENT_ROLE_SCHEMA[ENROLLMENT_ROLE_FACILITATOR],
            ENROLLMENT_ROLE_SCHEMA[ENROLLMENT_ROLE_TEACHER]
          ]
        }
      }
    case ENROLLMENT_CONTROL_FILTER_BY_ROLE_OBSERVER:
      return {
        filter,
        roleFilter: { eq: ENROLLMENT_ROLE_SCHEMA[ENROLLMENT_ROLE_OBSERVER] }
      }
    case ENROLLMENT_CONTROL_FILTER_BY_ROLE_STUDENT:
      return {
        filter,
        roleFilter: { eq: ENROLLMENT_ROLE_SCHEMA[ENROLLMENT_ROLE_STUDENT] }
      }
    case ENROLLMENT_CONTROL_FILTER_BY_ROLE_FACILITATOR:
      return {
        filter,
        roleFilter: { eq: ENROLLMENT_ROLE_SCHEMA[ENROLLMENT_ROLE_FACILITATOR] }
      }
    case ENROLLMENT_CONTROL_FILTER_BY_ROLE_TEACHER:
      return {
        filter,
        roleFilter: { eq: ENROLLMENT_ROLE_SCHEMA[ENROLLMENT_ROLE_TEACHER] }
      }
    case ENROLLMENT_CONTROL_FILTER_BY_ROLE_EDITOR:
      return {
        filter,
        roleFilter: { eq: ENROLLMENT_ROLE_SCHEMA[ENROLLMENT_ROLE_EDITOR] }
      }
    case ENROLLMENT_CONTROL_FILTER_BY_STAFF_ROLES:
      return {
        filter,
        roleFilter: {
          in: [
            ENROLLMENT_ROLE_SCHEMA[ENROLLMENT_ROLE_TEACHER],
            ENROLLMENT_ROLE_SCHEMA[ENROLLMENT_ROLE_FACILITATOR]
          ]
        }
      }
  }
}

export const getSortVariables = (sort) => {
  switch (sort) {
    case ENROLLMENT_CONTROL_SORT_BY_DATE_ACTIVE:
      return {
        sort,
        orderBy: { last_activity_time: OrderByDir.Desc }
      }
    case ENROLLMENT_CONTROL_SORT_BY_DATE_JOINED:
      return {
        sort,
        orderBy: { created: OrderByDir.Desc }
      }
  }
}

export const FILTERS = [
  ENROLLMENT_CONTROL_FILTER_BY_ALL_ROLES,
  ENROLLMENT_CONTROL_FILTER_BY_ROLE_STUDENT,
  ENROLLMENT_CONTROL_FILTER_BY_STAFF_ROLES,
  ENROLLMENT_CONTROL_FILTER_BY_ROLE_OBSERVER
  // ENROLLMENT_ROLE_EDITOR // not including editor role for now
]

export const SORTS = [
  ENROLLMENT_CONTROL_SORT_BY_DATE_ACTIVE,
  ENROLLMENT_CONTROL_SORT_BY_DATE_JOINED
]
